import type { FC, ReactElement } from "react"

import styles from "@/3514/components/shared/headers/headers.styles"
import { Link } from "@/3514/components/shared/link/link.component"
import { EUserRole } from "@/3514/types"
import { type TUseLogoNavigation, useLogoNavigation } from "@/hooks"
import ProductTypeLogo from "@/shared/ProductTypeLogo"

const HeaderLogo: FC = (): ReactElement => {
    const { logoNavigationUrl }: TUseLogoNavigation = useLogoNavigation()

    return (
        <Link to={logoNavigationUrl} className={styles[EUserRole.Coach].logoBlock()}>
            <ProductTypeLogo />
        </Link>
    )
}

HeaderLogo.displayName = "HeaderLogo"

export default HeaderLogo
